export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const GET_TYPING_CLIENTS_REQUEST = 'GET_TYPING_CLIENTS_REQUEST';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE';

export const GET_CLIENT_REQUEST = 'GET_CLIENT_REQUEST';
export const GET_CLIENT_SUCCESS = 'GET_CLIENT_SUCCESS';
export const GET_CLIENT_FAILURE = 'GET_CLIENT_FAILURE';

export const SET_CLIENTS = 'SET_CLIENTS';
export const SET_CLIENT = 'SET_CLIENT';

export const SUBMIT_CLIENT_REQUEST = 'SUBMIT_CLIENT_REQUEST';
export const SUBMIT_CLIENT_SUCCESS = 'SUBMIT_CLIENT_SUCCESS';
export const SUBMIT_CLIENT_FAILURE = 'SUBMIT_CLIENT_FAILURE';

export const getClientsRequest = (filters = {}) => ({
    type: GET_CLIENTS_REQUEST,
    payload: {
        filters
    }
});

export const getTypingClientsRequest = (filters = {}) => ({
    type: GET_TYPING_CLIENTS_REQUEST,
    payload: {
        filters
    }
});

export const getClientsSuccess = (clients, total, profiles) => ({
    type: GET_CLIENTS_SUCCESS,
    payload: {
        clients,
        total,
        profiles
    }
});

export const getClientsFailure = err => ({
    type: GET_CLIENTS_FAILURE,
    error: err
});

export const getClientRequest = (filters = {}) => ({
    type: GET_CLIENT_REQUEST,
    payload: {
        filters
    }
});

export const getClientSuccess = (client, profiles) => ({
    type: GET_CLIENT_SUCCESS,
    payload: {
        client,
        profiles
    }
});

export const getClientFailure = err => ({
    type: GET_CLIENT_FAILURE,
    error: err
});

export const setClients = (clients = [], total = 0) => ({
    type: SET_CLIENTS,
    payload: {
        clients,
        total
    }
});

export const setClient = (client = {}) => ({
    type: SET_CLIENT,
    payload: {
        client
    }
});

export const submitClientsRequest = (client, history) => ({
    type: SUBMIT_CLIENT_REQUEST,
    payload: { client },
    history
});

export const submitClientsSuccess = client => ({
    type: SUBMIT_CLIENT_SUCCESS,
    payload: {
        client
    }
});

export const submitClientsFailure = err => ({
    type: SUBMIT_CLIENT_FAILURE,
    error: err
});
